import { z } from 'zod';

type TProps = {
  min: number;
  max: number;
  defaultValue: number;
};
export default function createBoundNumberParser({ min, max, defaultValue }: TProps) {
  return z
    .preprocess((value) => {
      if (typeof value === 'boolean') {
        return defaultValue;
      }
      if (value instanceof Date) {
        return defaultValue;
      }
      return value ?? defaultValue;
    }, z.coerce.number())
    .default(defaultValue)
    .catch(defaultValue)
    .transform((num) => {
      if (num > max) {
        return max;
      }
      if (num < min) {
        return min;
      }
      return num;
    });
}
